import AIRewriterPoster from '@/shared/assets/images/ai-rewriter-poster.jpg';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const AI_REWRITE_DEMO_VIDEO_SRC = 'https://static.rask.ai/IA-2.mp4';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock AI rewrite feature',
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    poster: AIRewriterPoster,
    src: AI_REWRITE_DEMO_VIDEO_SRC,
    type: 'video',
    videoOptions: {
      autoPlay: true,
      controls: false,
      loop: true,
    },
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeAIRewriteModalClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeAIRewriteModalShown,
  subtitle: 'Upgrade to Creator Pro plan for speed control and AI-driven segment alignment to match your timestamps',
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT: ModalContent = {
  ...BASE_CONTENT,
};

export const AI_REWRITE_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
};
